




































































































































































































import { Component } from 'vue-property-decorator';
import { JournalEntriesModule } from '@/store/Accounting/JournalEntriesModule';
import SaascadaVue from '@/components/Shared/SaascadaVue';

@Component({ name: 'JournalEntryDetails' })
export default class extends SaascadaVue {

    get journalEntry() {
        return JournalEntriesModule.journalEntry;
    }

}
